import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import idiomas from './resources/idiomas.json'

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug:false,
        fallbackLng: 'es',
        load:'languageOnly',
        resources:idiomas
    })

export default i18next